<template>
  <v-card
    class="d-flex flex-column justify-center align-center"
    style="min-height: 400px; "
    elevation="0"
  >
    <div
      class="d-flex flex-column align-center justify-center"
      style="max-width: 290px"
    >
      <v-icon size="32" color="blue-grey lighten-1" class="mb-3"
        >mdi-database-remove-outline</v-icon
      >
      <p
        class="ma-0 pa-0 subtitle-2 blue-grey--text text--darken-1 mb-1"
        data-testid="empty_state_title"
      >
        {{ title }}
      </p>
      <p
        class="ma-0 pa-0 caption blue-grey--text text-center"
        data-testid="empty_state_content"
      >
        {{ content }}
      </p>

      <ActionsButton :data="action" />
    </div>
  </v-card>
</template>

<script>
import ActionsButton from '@/containers/ReportsView/Widgets/ActionsButton.vue'
export default {
  name: 'EmptyState',

  components: {
    ActionsButton,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    title() {
      return this.data?.title ?? ''
    },

    content() {
      return this.data?.content ?? ''
    },

    action() {
      return this.data?.action ?? {}
    },
  },
}
</script>
